module.exports = __webpack_public_path__ + "img/chair-solid.68538f21.svg";